import React from "react";
import { XHStackContainer } from "../../Containers";
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime } from "../../FormRuntime";
import { ImageFormControl } from "../Web/ImageFormControl";
import { ExecutionData } from "../../../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

function getUI(): { form: FormConfiguration } {
    let ui = new FormConfiguration();
    let container = new XHStackContainer();

    ui.add(container);

    let imageDisplayField = new ImageFormControl();
    imageDisplayField.valueName = "value";
    imageDisplayField.link = "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__480.jpg";
    imageDisplayField.fullWidth = true;
    container.add(imageDisplayField);

    return { form: ui };
}

export const ImageControlStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Image Control",
        "Full Width",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let cic = c as ImageFormControl;
                if (cic) {
                    cic.width = 300;
                    cic.fullWidth = false;
                }
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Image Control",
        "With Width",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let cic = c as ImageFormControl;
                if (cic) {
                    cic.staticImageLink = false;
                }
            }

            let data = new ExecutionData();
            data.values["value"] = "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885__480.jpg";

            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Image Control",
        "Static Image",
    ),
    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let cic = c as ImageFormControl;
                if (cic) {
                    cic.tooltip = "Tooltip";
                }
            }

            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Image Control",
        "With Tooltip",
    ),
];
